import { style } from '@vanilla-extract/css';
export const className = style({
    color: 'green',
});
